<template>
	<v-card>
		<v-card-title class="text-center justify-center">
			<h2> שתפו וצברו כרטיסים!</h2>
		</v-card-title>
		<v-card-subtitle>
			כל משתתף שיצטרף בזכותך יזכה אותך בכרטיס נוסף!!
		</v-card-subtitle>

		<v-card-actions class="justify-center">
			<!--            <div class="text-center d-flex justify-center">-->

			<v-btn
				class="mx-2"
				fab
				dark
				@click="copyTextToClipboard"
				color="teal"
			>
				<v-icon dark>
					mdi-content-copy
				</v-icon>
			</v-btn>
			<v-btn
				class="mx-2"
				fab
				dark
				target="_blank"
				color="teal"
				:href="`https://www.facebook.com/sharer/sharer.php?u=${link}&quote=${titleLink} ${subTitle} ${link}`"
			>
				<v-icon dark>
					mdi-facebook
				</v-icon>
			</v-btn>
			<v-btn
				class="mx-2"
				fab
				dark
				target="_blank"
				color="teal"
				:href="`https://api.whatsapp.com/send?text=${titleLink} ${subTitle} ${link}`"
			>
				<v-icon dark>
					mdi-whatsapp
				</v-icon>
			</v-btn>
			<v-btn
				class="mx-2"
				fab
				dark
				target="_blank"
				color="teal"
				:href="`mailto:?subject=${titleLink}&body= ${subTitle} ${link} `"
			>
				<v-icon dark>
					mdi-email
				</v-icon>
			</v-btn>

			<!--            </div>-->
		</v-card-actions>
	</v-card>
</template>

<script>
	export default {
		name: "share-card",
		props: {
			title: String,
			subTitle: String,
			link: String,
			titleLink: String
		}, methods: {
			copyTextToClipboard() {
				let text = this.link;
				let textArea = document.createElement("textarea");


				// Place in the top-left corner of screen regardless of scroll position.
				textArea.style.position = "fixed";
				textArea.style.top = 0;
				textArea.style.left = 0;

				// Ensure it has a small width and height. Setting to 1px / 1em
				// doesn't work as this gives a negative w/h on some browsers.
				textArea.style.width = "2em";
				textArea.style.height = "2em";

				// We don't need padding, reducing the size if it does flash render.
				textArea.style.padding = 0;

				// Clean up any borders.
				textArea.style.border = "none";
				textArea.style.outline = "none";
				textArea.style.boxShadow = "none";

				// Avoid flash of the white box if rendered for any reason.
				textArea.style.background = "transparent";


				textArea.value = text;

				document.body.appendChild(textArea);
				textArea.focus();
				textArea.select();

				try {
					let successful = document.execCommand("copy");
					this.$notfication.success("הקישור הועתק ל clipboard");
				} catch (err) {
					this.$notfication.success(text);
				}

				document.body.removeChild(textArea);
			}
		}
	};
</script>

<style scoped>

</style>
